/* eslint-disable react/jsx-key */
import React, { lazy } from 'react'
import AuthorizedRoute from '../components/AuthorizedRoute'
import UnauthorizedRoute from '..//components/UnauthorizedRoute'

const SignIn = lazy(() => import('../pages/SignIn/SignIn'))
const SignUp = lazy(() => import('../pages/SignUp/SignUp'))
const PasswordReset = lazy(() => import('../pages/PasswordReset/PasswordReset'))
const MyAccount = lazy(() => import('../pages/MyAccount/MyAccount')) 
const Dashboard = lazy(() => import('../pages/Dashboard/Dashboard'))
const Trends = lazy(() => import('../pages/Trends/Trends'))
const Alarm = lazy(() => import('../pages/Alarm/Alarm'))
const Log = lazy(() => import('../pages/Log/Log'))
const About = lazy(() => import('../pages/About'))

const Home = lazy(() => import('../pages/Home/Home'))
const Users = lazy(() => import('../pages/Users/Users'))
const Models = lazy(() => import('../pages/Models/Models'))
const Sites = lazy(() => import('../pages/Sites/Sites'))
const Groups = lazy(() => import('../pages/Groups/Groups'))
const Control = lazy(() => import('../pages/Control/Control'))
const Update = lazy(() => import('../pages/Update/Update'))

const routes = [
  {
    path: '/signin',
    exact: true,
    element: (
      <UnauthorizedRoute>
        <SignIn redirectTo="/dashboard" />
      </UnauthorizedRoute>
    ),
  },
  {
    path: '/signup',
    exact: true,
    element: (
      <UnauthorizedRoute>
        <SignUp redirectTo="/dashboard" />
      </UnauthorizedRoute>
    ),
  },
  {
    path: '/password_reset',
    exact: true,
    element: (
      <UnauthorizedRoute>
        <PasswordReset />
      </UnauthorizedRoute>
    ),
  },
  {
    path: '/my_account',
    exact: true,
    element: (
      <AuthorizedRoute>
        <MyAccount />
      </AuthorizedRoute>
    ),
  },
  {
    path: '/home',
    exact: true,
    element: (
      <AuthorizedRoute>
        <Home />
      </AuthorizedRoute>
    ),
  },
  {
    path: '/dashboard',
    exact: true,
    element: (
      <AuthorizedRoute>
        <Dashboard />
      </AuthorizedRoute>
    ),
  },
  {
    path: '/trends',
    exact: true,
    element: (
      <AuthorizedRoute>
        <Trends />
      </AuthorizedRoute>
    ),
  },
  {
    path: '/alarm',
    exact: true,
    element: (
      <AuthorizedRoute>
        <Alarm />
      </AuthorizedRoute>
    ),
  },
  {
    path: '/log',
    exact: true,
    element: (
      <AuthorizedRoute>
        <Log />
      </AuthorizedRoute>
    ),
  },
  // {
  //   path: '/about',
  //   exact: true,
  //   element: <About />,
  // },
  {
    path: '/about',
    exact: true,
    element: (
      <AuthorizedRoute>
        <About />
      </AuthorizedRoute>
    ),
  },
  {
    path: '/groups',
    exact: true,
    element: (
      <AuthorizedRoute>
        <Groups />
      </AuthorizedRoute>
    ),
  },
  {
    path: '/sites',
    exact: true,
    element: (
      <AuthorizedRoute>
        <Sites />
      </AuthorizedRoute>
    ),
  },
  {
    path: '/users',
    exact: true,
    element: (
      <AuthorizedRoute>
        <Users />
      </AuthorizedRoute>
    ),
  },
  {
    path: '/models',
    exact: true,
    element: (
      <AuthorizedRoute>
        <Models />
      </AuthorizedRoute>
    ),
  },
  {
    path: '/control',
    exact: true,
    element: (
      <AuthorizedRoute>
        <Control />
      </AuthorizedRoute>
    ),
  },
  {
    path: '/update',
    exact: true,
    element: (
      <AuthorizedRoute>
        <Update />
      </AuthorizedRoute>
    ),
  },
]

export default routes
